var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloudAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46316 12.9734C1.00316 13.3584 1.00316 21.3034 6.46316 21.6884H8.70321",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52138 12.9734C2.77638 2.55508 18.573 -1.60991 20.3813 9.33342C25.433 9.97509 27.4747 16.7068 23.648 20.0551C22.4814 21.1168 20.9764 21.7001 19.4014 21.6884H19.2963",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8337 19.285C19.8337 20.1483 19.647 20.965 19.297 21.6883C19.2036 21.8983 19.0987 22.0967 18.982 22.2833C17.9787 23.975 16.1237 25.1183 14.0003 25.1183C11.877 25.1183 10.022 23.975 9.01864 22.2833C8.90197 22.0967 8.79702 21.8983 8.70368 21.6883C8.35368 20.965 8.16699 20.1483 8.16699 19.285C8.16699 16.065 10.7803 13.4517 14.0003 13.4517C17.2203 13.4517 19.8337 16.065 19.8337 19.285Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1797 19.2849L13.3347 20.4399L15.8197 18.1416",
    stroke: "white",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudAdd);
export default __webpack_public_path__ + "static/media/cloud-add.251d63cc788aadf36371397786d03995.svg";
export { ForwardRef as ReactComponent };